import { myCustomLightTheme } from '@/utils/theme'

export default (colorText: string): string =>
  (myCustomLightTheme.colors as any)[colorText] || colorText
